module.exports = __webpack_public_path__ + "img/image4.129e33a0.png";